import type { FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import styles from "./AuthoringWarningMessage.module.scss";

type AuthoringWarningMessageProps = {
  message: string;
  isSuccessfullyValidated: boolean;
};

/**
 * This component is used to display a warning message when the user is in authoring mode and a condition is met.
 * It also prevents component from being rendered in preview or publish mode when the condition is not met.
 */
export const AuthoringWarningMessage: FC<PropsWithChildren<AuthoringWarningMessageProps>> = ({
  message,
  isSuccessfullyValidated,
  children,
}) => {
  if (isEditing() && !isSuccessfullyValidated) {
    return (
      <>
        {children}
        <div className={styles.message}>{message}</div>
      </>
    );
  }

  if (!isEditing() && !isSuccessfullyValidated) {
    return null;
  }

  return children;
};
